export const EMPLOYEE_TYPES = {
  1: {
    name: 'W2 + Benefits',
    overhead: 25.0000
  },
  2: {
    name: 'W2 No Benefits',
    overhead: 15.0000
  },
  3: {
    name: 'C2C',
    overhead: 0
  },
  4: {
    name: '1099',
    overhead: 0
  }
}

export const EMPLOYEE_WITH_BENEFITS = 1

export const EMPLOYEE_NO_BENEFITS = 2

export const CORP_TO_CORP = 3

export const INDEPENDENT_CONTRACTOR = 4

// Time Off Eligible is derived from the Employee Type, never stored (ADR 0014).
export function isTimeOffEligible (employeeTypeId) {
  return employeeTypeId === EMPLOYEE_WITH_BENEFITS
}
